

























































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import SeparatorComponent from '@/shared/components/SeparatorComponent.vue'
import IconTextComponent from '@/shared/components/IconTextComponent.vue'
import EmployeeComponent from '@/shared/components/EmployeeComponent.vue'
// import GoogleMapsComponent from '@/shared/components/GoogleMapsComponent.vue'
import textResource from '@/assets/locales/de.json'

@Component({
    name: 'home',
    components: {
        'ldw-separator': SeparatorComponent,
        'ldw-icon-text': IconTextComponent,
        'ldw-employee': EmployeeComponent
        // 'ldw-gmaps': GoogleMapsComponent
    }
})

export default class Home extends Vue {
    public textResource: {} = textResource
}
